import { Select } from "@npm_leadtech/qr-ui-components";
import { SelectAdapterProps } from "./types";
import { useSelectAdapter } from "./hooks";

export function SelectAdapter(props: SelectAdapterProps) {
  const {
    name,
    defaultValue,
    value,
    error,
    errorMessage,
    success,
    loading,
    disabled,
    onChange,
    onClick,
    rules,
    ...restProps
  } = props;

  const { currentValue, status, finalErrorMessage, isDisabled, handleChange } = useSelectAdapter({
    name,
    defaultValue,
    value,
    error,
    errorMessage,
    success,
    loading,
    disabled,
    onChange,
    onClick,
    rules,
  });

  return (
    <Select
      {...restProps}
      name={name}
      value={currentValue}
      multiple={false}
      onChange={handleChange}
      status={status}
      errorMessage={finalErrorMessage}
      disabled={isDisabled}
      tooltipHelperItem={
        props.tooltipHelperItem && props.tooltipHelperItem.position
          ? {
              ...props.tooltipHelperItem,
              position: props.tooltipHelperItem.position,
            }
          : props.tooltipHelperItem
      }
    />
  );
}
